export const LAYOUT_MAIN_REQUIRED_ERR =
	'LayoutMain is required when using Layout.';
